import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { captureException } from '@sentry/react';
import { getCycleCountLocationRows } from '@/components/CycleCounts/utils';
import {
    CYCLE_COUNT_LOCATION_BY_PK,
    CYCLE_COUNT_LOCATION_EXPECTED_ITEMS,
} from './graphql/queries';

export function useCycleCountLocationDetails(cycleCountLocationId) {
    const {
        data: locationData,
        loading: locationLoading,
    } = useQuery(CYCLE_COUNT_LOCATION_BY_PK, {
        variables: { cycle_count_location_id: cycleCountLocationId },
        skip: !cycleCountLocationId,
        fetchPolicy: 'cache-and-network',
        onError: (error) => captureException(error),
    });

    const countLocation = locationData?.cycle_count_locations_by_pk;
    const warehouseId = countLocation?.cycle_count?.warehouse_id;
    const warehouseLocation = countLocation?.warehouse_location;

    const {
        data: expectedItemsData,
        loading: expectedLoading,
    } = useQuery(CYCLE_COUNT_LOCATION_EXPECTED_ITEMS, {
        variables: { warehouse_id: warehouseId, warehouse_location: warehouseLocation },
        skip: !warehouseId || !warehouseLocation,
        fetchPolicy: 'cache-and-network',
        onError: (error) => captureException(error),
    });

    const rows = useMemo(
        () => getCycleCountLocationRows(countLocation, expectedItemsData?.items),
        [countLocation, expectedItemsData?.items]
    );

    return {
        countLocation,
        rows,
        loading: locationLoading || (warehouseId && warehouseLocation && expectedLoading),
    };
}
